import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  palette, fontWeights,
}: Theme) => ({
  colored: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.625rem',
    padding: '2rem',
  },
  title: {
    fontWeight: fontWeights.medium,
    color: palette.common.white,
    textAlign: 'center',
  },
  content: {
    paddingTop: '1.5rem',
  },
  message: {
    position: 'relative',
    margin: 0,
    padding: '0.75rem 2.25rem 0.75rem 0.75rem',
    borderRadius: '0.5rem',
    fontSize: '0.75rem',
    lineHeight: 1.3,
  },
  byPhone: {
    background: 'linear-gradient(135deg, #fac7d5 0%, #fde1B7 100%)',
    letterSpacing: 0,
  },
  cvDates: {
    background: 'rgba(34, 34, 34, 0.1)',
    color: palette.common.white,
    '& circle, & path': {
      stroke: palette.common.white,
    },
  },
  phone: {
    display: 'block',
    color: palette.primary.dark,
    textDecoration: 'none',
  },
  icon: {
    position: 'absolute',
    right: '0.75rem',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '1rem',
    objectFit: 'contain',
  },
}));
